import { Chain } from '@ankr.com/chains-list';

import { ChainDescription } from 'modules/chains/components/ChainDescription';

import { useChainOverviewStyles } from './useChainOverviewStyles';

interface ChainOverviewProps {
  addToProjectButton?: React.ReactNode;
  chain: Chain;
  chainMenu?: React.ReactNode;
}

export const ChainOverview = ({
  addToProjectButton,
  chain,
  chainMenu,
}: ChainOverviewProps) => {
  const { classes } = useChainOverviewStyles();

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <ChainDescription chain={chain} />
      </div>
      <div className={classes.right}>
        {addToProjectButton}
        {chainMenu}
      </div>
    </div>
  );
};
